import { useState, useEffect, Fragment } from 'react';
import api from '../services/api';
import {
  LuKeyRound, LuCheck,
} from 'react-icons/lu';
import { groups } from './Navigation';

const ROLES = [
  { key: 'admin',    label: 'Administrador' },
  { key: 'gestor',   label: 'Gestor' },
  { key: 'operador', label: 'Operador' },
];

// Página que nunca pode ser tirada do próprio Admin — senão ninguém sem ser
// superadmin conseguiria voltar aqui para corrigir um erro de configuração.
const LOCKED = { admin: new Set(['RolePermissionsPage']) };

export default function RolePermissionsPage() {
  const [matrix,  setMatrix]  = useState(null); // { admin: Set, gestor: Set, operador: Set }
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    api.get('/role-permissions')
      .then((r) => {
        const next = {};
        for (const { role, pages } of r.data) next[role] = new Set(pages);
        setMatrix(next);
      })
      .catch(() => setError('Erro ao carregar permissões'))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (role, pageId) => {
    if (LOCKED[role]?.has(pageId)) return;
    setMatrix((prev) => {
      const next = { ...prev, [role]: new Set(prev[role]) };
      next[role].has(pageId) ? next[role].delete(pageId) : next[role].add(pageId);
      return next;
    });
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await Promise.all(
        ROLES.map(({ key }) => api.put(`/role-permissions/${key}`, { pages: [...matrix[key]] }))
      );
      setSuccess('Permissões salvas com sucesso');
      setTimeout(() => setSuccess(''), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Erro ao salvar permissões');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-card">
      <div className="page-card-header">
        <div>
          <div className="page-card-title">Permissões</div>
          <div className="page-card-subtitle">Defina quais telas cada papel de usuário pode acessar</div>
        </div>
        <button className="btn-salvar" onClick={handleSave} disabled={saving || loading}>
          <LuCheck style={{ marginRight: 6 }} /> {saving ? 'Salvando…' : 'Salvar alterações'}
        </button>
      </div>

      {error   && <div className="alert-custom danger"  style={{ marginBottom: 12 }}>{error}</div>}
      {success && <div className="alert-custom success" style={{ marginBottom: 12 }}>{success}</div>}

      {loading && <div style={{ color: 'var(--text-3)', fontSize: 13, padding: '16px 0' }}>Carregando…</div>}

      {!loading && matrix && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border)' }}>
                <th style={{ padding: '9px 12px', textAlign: 'left', color: 'var(--text-3)', fontWeight: 600 }}>
                  <LuKeyRound style={{ marginRight: 6, verticalAlign: '-2px' }} />Página
                </th>
                {ROLES.map((r) => (
                  <th key={r.key} style={{ padding: '9px 12px', textAlign: 'center', color: 'var(--text-3)', fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {r.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {groups.map((group) => (
                <Fragment key={group.label}>
                  <tr style={{ background: 'var(--surface-2)' }}>
                    <td colSpan={ROLES.length + 1} style={{ padding: '8px 12px', fontWeight: 700, color: 'var(--text-1)', fontSize: 12 }}>
                      {group.label}
                    </td>
                  </tr>
                  {group.items.map((item) => (
                    <tr key={item.id} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '9px 12px', color: 'var(--text-2)' }}>{item.label}</td>
                      {ROLES.map((r) => {
                        const locked = LOCKED[r.key]?.has(item.id);
                        return (
                          <td key={r.key} style={{ padding: '9px 12px', textAlign: 'center' }}>
                            <input
                              type="checkbox"
                              checked={matrix[r.key].has(item.id)}
                              onChange={() => toggle(r.key, item.id)}
                              disabled={locked}
                              title={locked ? 'Não pode ser removida do Administrador' : ''}
                              style={{ width: 16, height: 16, accentColor: 'var(--accent)', cursor: locked ? 'not-allowed' : 'pointer' }}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
